import classNames from 'classnames';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { useCallback, useMemo } from 'react';

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  setPage: (newPage: number) => void;
}

function Pagination({ currentPage, totalPages, setPage }: PaginationProps) {
  const changePage = useCallback(
    (newPage: number) => {
      if (newPage > 0 && newPage <= totalPages) {
        setPage(newPage);
      }
    },
    [setPage, totalPages]
  );

  const pagination = useMemo(() => {
    const pages = [];
    let firstPage = 1;
    let lastPage = totalPages;
    if (totalPages > 10) {
      firstPage = Math.max(currentPage - 4, 1);
      lastPage = Math.min(currentPage + 4, totalPages);
    }
    for (let i = firstPage; i <= lastPage; i++) {
      pages.push(
        <div
          key={i}
          role={currentPage !== i ? 'button' : undefined}
          className={classNames(
            'flex h-9 flex-nowrap items-center justify-center px-3 py-2 font-semibold',
            currentPage !== i && 'text-link underline'
          )}
          onClick={currentPage !== i ? () => changePage(i) : undefined}
        >
          {i}
        </div>
      );
    }
    return pages;
  }, [changePage, currentPage, totalPages]);

  if (totalPages <= 1) {
    return null;
    // <div className="my-4 inline-flex flex-row">
    //   <div className="h-9"></div>
    // </div>
  }
  return (
    <div className="my-4 inline-flex flex-row rounded-md border border-neutral-200">
      <div
        role={currentPage > 1 ? 'button' : undefined}
        className={classNames(
          'flex h-9 flex-nowrap items-center justify-center px-3 py-2 font-semibold',
          currentPage > 1 && 'text-link underline'
        )}
        onClick={() => changePage(currentPage - 1)}
      >
        <ChevronLeftIcon size={20} />
      </div>

      {pagination}

      <div
        role={currentPage < totalPages ? 'button' : undefined}
        className={classNames(
          'flex h-9 flex-nowrap items-center justify-center px-3 py-2 font-semibold',
          currentPage < totalPages && 'text-link underline'
        )}
        onClick={() => changePage(currentPage + 1)}
      >
        <ChevronRightIcon size={20} />
      </div>
    </div>
  );
}

export default Pagination;
